module.exports = __webpack_public_path__ + "static/media/resource6.80c0c447.svg";